import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { NowCompactProductCard } from './NowCompactProductCard';
interface NowProduct {
  id: number;
  name: string;
  brand?: string;
  price: number;
  originalPrice?: number;
  discount?: number;
  rating?: number;
  reviewCount?: number;
  image: string;
  isBestSeller?: boolean;
  isNew?: boolean;
  expressDelivery?: boolean;
  isGlobal?: boolean;
  endingSoon?: boolean;
}
interface NowProductRailProps {
  title: string;
  subtitle: string;
  viewAllLink: string;
  products: NowProduct[];
}
export function NowProductRail({
  title,
  subtitle,
  viewAllLink,
  products
}: NowProductRailProps) {
  const navigate = useNavigate();
  return <section aria-label={title} className="w-full" data-id="element-4535" data-mp="1oa0ffh9vugcj">
      <div className="mb-4 flex items-end justify-between gap-4" data-id="element-4536" data-mp="228gpni6yeozf">
        <div data-id="element-4537" data-mp="228qdaz4j0k1y">
          <h2 className="text-xl font-bold tracking-tight text-gray-900 md:text-2xl" data-id="element-4538" data-mp="22646j1pgm8ks">{title}</h2>
          <p className="mt-1 text-sm text-gray-600" data-id="element-4539" data-mp="1x7j5x16apmvt">{subtitle}</p>
        </div>
        <button type="button" onClick={() => navigate(viewAllLink)} className="inline-flex flex-shrink-0 items-center gap-1 text-sm font-bold text-[#1E2B55] transition-colors duration-150 hover:text-[#315b96]" data-id="element-4540" data-mp="3bviqnv1uhh4f">
          View all <ChevronRightIcon className="h-4 w-4" data-id="element-4541" data-mp="3qr8hc6hz6ifh" />
        </button>
      </div>
      <div className="grid grid-flow-col grid-rows-1 auto-cols-[calc((100%_-_16px)_/_3)] gap-2 overflow-x-auto pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:auto-cols-[calc((100%_-_16px)_/_3)] md:auto-cols-[185px] md:gap-3 lg:auto-cols-[205px]" data-id="element-4542" data-mp="3usk13ve649fr">
        {products.map(product => <NowCompactProductCard key={product.id} product={product} data-id="element-4543" data-mp="dbsn7h3wlop3" />)}
      </div>
    </section>;
}